import { Link } from 'react-router-dom'

export default function Support() {
  return (
    <div className="min-h-screen p-8">
      <div className="max-w-6xl mx-auto">
        <nav className="mb-8">
          <Link to="/" className="text-blue-600 hover:text-blue-800 mr-4">Home</Link>
          <span className="text-gray-500">Support</span>
        </nav>
        <h1 className="text-3xl font-bold mb-6">Support</h1>
        <p className="text-muted-foreground">Support content will be migrated here...</p>
      </div>
    </div>
  )
}